// extracted by mini-css-extract-plugin
export var container = "_3r-0";
export var error = "_3r-9";
export var label = "_3r-5";
export var light = "_3r-6";
export var md = "_3r-3";
export var sm = "_3r-2";
export var thin = "_3r-8";
export var thinBold = "_3r-7";
export var vertical = "_3r-4";
export var xs = "_3r-1";